/**
 * TryQuiPus — Paleta semántica por tema
 *
 * Los valores NO viven aquí: vienen de src/styles/tokens.json → tokens-v2.css (`npm run tokens`).
 * `colors()` devuelve referencias `var(--…)`; el modo claro/oscuro lo resuelve el CSS (:root.dark),
 * por eso el resultado ya no depende de `isDark`. El parámetro se conserva para no tocar los
 * ~80 llamadores existentes.
 *
 * Uso:
 *   const c = colors(isDark);
 *   style={{ background: c.card, color: c.textPrimary, border: `1px solid ${c.border}` }}
 *
 * Transparencia: NO concatenar hex-alfa (`${c.info}1f`) — una `var()` no es un hex.
 * Usa `alpha(c.info, 12)` (color-mix), que funciona con cualquier color o variable.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- parámetro conservado por compatibilidad con los llamadores
export const colors = (_isDark?: boolean) => ({
  // ── Fondos ───────────────────────────────────────────────────────
  card:        'var(--surface)',
  cardAlt:     'var(--surface-raised)',
  canvas:      'var(--canvas)',
  modal:       'var(--surface)',

  // ── Textos ───────────────────────────────────────────────────────
  textPrimary: 'var(--ink)',
  textNormal:  'var(--body)',
  textSub:     'var(--muted)',
  textMuted:   'var(--muted)',

  // ── Bordes ───────────────────────────────────────────────────────
  border:      'var(--border)',
  borderSoft:  'var(--border)',
  borderInput: 'var(--border-strong)',

  // ── Inputs ───────────────────────────────────────────────────────
  inputBg:     'var(--surface-raised)',

  // ── Fondos sutiles ───────────────────────────────────────────────
  subtleBg:    'var(--surface-raised)',
  trackBg:     'var(--surface-raised)',

  // ── Tablas ───────────────────────────────────────────────────────
  tableHead:     'var(--surface-raised)',
  tableTotal:    'var(--surface-raised)',
  cardElevated:  'var(--surface-raised)',

  // ── Semánticos ───────────────────────────────────────────────────
  positive:    'var(--positive)',
  negative:    'var(--negative)',
  warning:     'var(--warning)',
  info:        'var(--brand)',
});

/** Aplica transparencia (0–100 %) a un color o `var(--…)`. Sustituye a la concatenación de hex-alfa. */
export const alpha = (color: string, percent: number): string =>
  `color-mix(in srgb, ${color} ${percent}%, transparent)`;
